import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import MdSearch from 'react-icons/lib/md/search';

import { media } from '../../../styles';

import IconButton from '../../ui/IconButton';
import TextField from '../../ui/TextField';

const Container = glamorous.div({
  display: 'flex',
  position: 'relative',
}, props => ({
  [media('xs', { isMax: true })]: props.size === 'default' && props.focused && {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'center',
    right: 0,
    top: 0,
    left: 56,
    height: '100%',
    paddingRight: 16,

    backgroundColor: props.theme.primary.base,

    '& .TextFieldContainer': {
      width: '100%',
      maxWidth: '100%',
    },
  },

  [media('sm', { isMax: true })]: props.size === 'default' && {
    '& .TextFieldContainer': {
      minWidth: props.focused ? 200 : 32,
      width: props.focused ? 'auto' : 32,
    },

    '& .TextFieldPlaceholder': {
      opacity: props.focused ? 1 : 0,
    },

    '& .TextField': {
      opacity: props.focused ? 1 : 0,
    },
  },
}));

const styleSearchButton = {
  backgroundColor: 'transparent !important',
  color: 'inherit',
};

class SearchTextField extends React.PureComponent {
  static propTypes = {
    focused: PropTypes.bool,
    onSearch: PropTypes.func,
    size: PropTypes.oneOf([
      'default',
      'small',
      'large',
    ]),
    value: PropTypes.string,
  };

  static defaultProps = {
    focused: false,
    onSearch: () => {},
    size: 'default',
    value: '',
  };

  state = {
    focused: this.props.focused,
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.value) {
      this.setFocused(true);
    } else if (nextProps.focused !== this.state.focused) {
      this.setFocused(nextProps.focused);
    }
  }

  get iconSize() {
    switch (this.props.size) {
      case 'large':
        return 32;
      default:
        return 16;
    }
  }

  handleBlur = () => {
    if (!this.props.value) {
      this.setFocused(false);
    }
  };

  handleFocus = () => {
    this.setFocused(true);
  };

  handleSearch = (e) => {
    if (!this.props.value) {
      this.ref && this.ref.focus();
      return this.setFocused(true);
    } else {
      this.ref && this.ref.blur();
    }


    return this.props.onSearch(e, this.props.value);
  };

  setFocused = focused => {
    this.setState({ focused });
  };

  setInnerRef = (ref) => {
    if (ref && !this.ref) {
      this.ref = ref;
    }
  }

  render() {
    const {
      size,
    } = this.props;

    return (
      <Container focused={this.state.focused} size={size}>
        <TextField
          {...this.props}
          focused={this.state.focused}
          placeholder="Search for events"
          color="white"
          textColor="white"
          size={this.props.size}
          rounded
          onBlur={this.handleBlur}
          onFocus={this.handleFocus}
          rightButton={
            <IconButton
              onClick={this.handleSearch}
              label={<MdSearch size={this.iconSize} />}
              style={styleSearchButton}
              size={this.props.size}
            />
          }
          innerRef={this.setInnerRef}
        />
      </Container>
    );
  }
}

export default SearchTextField;



// WEBPACK FOOTER //
// ./src/components/features/SearchTextField/SearchTextField.js